import React from 'react'
import { colors } from '../../../../styles/vars/colors.style'

const ExpeditionRoute2 = ({
  width = 280,
  height = 307,
  stroke = colors.dark,
  mask = colors.light,
  opacity = 1,
  pathLength = 595,
  responsive = true,
  forwardRef = null,
}) => {
  const svgAttributes = responsive
    ? {}
    : {
        width,
        height,
      }

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 280 307"
      focusable="false"
      role="img"
      fill="none"
      {...svgAttributes}
    >
      <path
        opacity={opacity}
        stroke={stroke}
        strokeWidth={1}
        strokeDasharray="2 3"
        d="M124.001,6.00098C105.501,21.001 101.081,26.7998 91.0007,42.001C82.7118,54.501 86.8584,68.5721 96.3369,89.5574C103.92,106.346 69.9325,115.767 44.882,126.113C13.7384,138.975 -2.24,157.252 1.55141,181.622C6.29068,212.084 14.8688,227.501 67.0007,227.501C119.133,227.501 133.059,244.064 130.35,253.541C127.642,263.018 126.288,275.88 142.537,268.434C158.786,260.987 198.731,258.956 220.397,260.987C242.062,263.018 257.15,272.934 279.001,306.001"
      />
      <path
        opacity={opacity}
        stroke={mask}
        strokeWidth={2}
        ref={forwardRef.line}
        strokeDashoffset={0}
        strokeDasharray={pathLength}
        d="M124.001,6.00098C105.501,21.001 101.081,26.7998 91.0007,42.001C82.7118,54.501 86.8584,68.5721 96.3369,89.5574C103.92,106.346 69.9325,115.767 44.882,126.113C13.7384,138.975 -2.24,157.252 1.55141,181.622C6.29068,212.084 14.8688,227.501 67.0007,227.501C119.133,227.501 133.059,244.064 130.35,253.541C127.642,263.018 126.288,275.88 142.537,268.434C158.786,260.987 198.731,258.956 220.397,260.987C242.062,263.018 257.15,272.934 279.001,306.001"
      />
      <path
        opacity={0}
        ref={forwardRef.arrow}
        d="M126.751 3.34048C126.978 3.29716 127.166 3.51565 127.09 3.73376L125.003 9.73173C124.927 9.94984 124.643 10.004 124.492 9.82919L120.342 5.02236C120.191 4.84757 120.286 4.57494 120.513 4.53162L126.751 3.34048Z"
        fill={stroke}
      />
    </svg>
  )
}

export default ExpeditionRoute2
